<template>
  <div>
    <app-navbar></app-navbar>
    <router-view></router-view>
    <portal-target name="flyout-sidebar" slim />
  </div>
</template>

<script>
import AppNavbar from "@/components/AppNavbar";

export default {
  provide() {
    return {
      appContext: {
        userLocation: this.userLocation,
      },
    };
  },
  components: {
    AppNavbar,
  },
  data() {
    return {
      userLocation: {
        latitude: 0,
        longitude: 0,
      },
    };
  },
  created() {
    this.getUserLocation();
  },
  methods: {
    getUserLocation() {
      if (!navigator.geolocation) {
        this.$toast.error(
          "Location is required for better experience but your browser doesn't support it."
        );
      } else {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.userLocation.latitude = position.coords.latitude;
            this.userLocation.longitude = position.coords.longitude;
          },
          () => {
            this.$toast.error(
              "Location is required for better experience, please accept location permission."
            );
          }
        );
      }
    },
  },
};
</script>